import React from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import { DEFAULT_NAMESPACE } from '@backstage/catalog-model';

import { StorageAccount } from '../StorageAccount';
import { StorageAccountProvider } from '../hooks';

export const StorageAccountContent = () => {
  const { entity } = useEntity();

  const namespace = entity?.metadata?.namespace || DEFAULT_NAMESPACE;
  const name = entity?.metadata?.name || '';

  return (
    <StorageAccountProvider name={name} namespace={namespace}>
      <StorageAccount />
    </StorageAccountProvider>
  );
};
